import { useState } from 'react';

import { TFormalOffer } from '@helpers/FormalOffers/formalOffers.types';

import { OffersPageShell } from './components/OffersPageShell';
import { FlexiApprovedView } from './FlexiApprovedView/FlexiApprovedView';
import { LoanSummary } from './LoanSummary/LoanSummary';
import { FundingProgressIndicator } from '../FundingProgressIndicator/FundingProgressIndicator';

export const FlexiApprovedPage = () => {
    const [selectedOffer, setSelectedOffer] = useState<
        TFormalOffer | undefined
    >();
    const [drawdownAmount, setDrawdownAmount] = useState<number | undefined>();
    const [isSingleOffer, setIsSingleOffer] = useState(false);

    return (
        <OffersPageShell
            progressIndicator={<FundingProgressIndicator step={3} />}
            mainContent={
                <FlexiApprovedView
                    onSelectedOfferChange={setSelectedOffer}
                    onDrawdownAmountChange={setDrawdownAmount}
                    onIsSingleOfferChange={setIsSingleOffer}
                />
            }
            sidePanel={
                <LoanSummary
                    selectedOffer={selectedOffer}
                    drawdownAmount={drawdownAmount}
                    isSingleOffer={isSingleOffer}
                />
            }
        />
    );
};
